<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 商品中心->已导入订单 -->
    <div class="main2">
      <div class="main2">
        <div class="search flexStyle2">
          <el-form
            :model="queryParams"
            ref="queryForm"
            :inline="true"
            label-width="90px"
          >
            <el-form-item label="订单编号：" prop="orderNum">
              <el-input
                v-model="queryParams.orderNum"
                placeholder="请输入订单编号"
                clearable
                size="small"
              />
            </el-form-item>
            <el-form-item label="订单时间：" prop="beginTime">
              <el-date-picker
                clearable
                size="small"
                style="width: 150px"
                v-model="queryParams.beginTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="开始时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="" prop="endTime">
              <el-date-picker
                clearable
                size="small"
                style="width: 150px"
                v-model="queryParams.endTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="截止时间"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button
                icon="el-icon-search"
                size="small"
                style="border-color:#97c5e9"
                @click="search"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="list">
          <el-table
            :data="aryList"
            border
            style="width:100%;"
            :cell-style="{
              'text-align': 'center',
              'border-color': '#dbdbdb',
            }"
            :header-cell-style="{
              'background-color': '#e7e6e4',
              color: '#000',
              fontSize: '14px',
              fontWeight: '300',
              'text-align': 'center',
              'border-color': '#e7e6e4',
            }"
            @selection-change="SelectionChange"
          >
            <el-table-column prop="num" align="center" label="序号" width="65">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>

            <el-table-column prop="batchName" label="单号" min-width="150">
              <template slot-scope="scope">
                {{ scope.row.batchName }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="导入时间" min-width="165">
              <template slot-scope="scope">
                {{ scope.row.createTime }}
              </template>
            </el-table-column>
            <el-table-column
              prop="orderCount"
              label="子定单数量"
              min-width="90"
            >
              <template slot-scope="scope">
                {{ scope.row.orderCount }}
              </template>
            </el-table-column>

            <el-table-column
              prop="goodsAmount"
              label="商品总额"
              min-width="100"
            >
              <template slot-scope="scope">
                {{ to_f(scope.row.goodsAmount || 0.0) }}
              </template>
            </el-table-column>
            <el-table-column prop="freight" label="运费" min-width="100">
              <template slot-scope="scope">
                {{ to_f(scope.row.freight || 0.0) }}
              </template>
            </el-table-column>
            <el-table-column prop="sumAmount" label="总额" min-width="100">
              <template slot-scope="scope">
                {{ to_f(scope.row.sumAmount || 0.0) }}
              </template>
            </el-table-column>

            <el-table-column prop="consigneeAddr" label="状态" min-width="85">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 0">已支付</span>
                <span v-else-if="scope.row.status == 1">未支付</span>
                <span v-else>已取消</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="90">
              <template slot-scope="scope">
                <div>
                  <el-button
                    size="mini"
                    style="border-color:#97c5e9"
                    @click="watchOrder(scope.row)"
                    >查看</el-button
                  >
                  <!-- <div style="height: 3px;clear:both;"></div>
                  <el-button
                    size="mini"
                    style="border-color:#97c5e9"
                    v-if="scope.row.status == 1"
                    @click="cancelOrderBefore(scope.row)"
                    >取消</el-button
                  > -->
                  <div style="height: 3px;clear:both;"></div>
                  <el-button
                    size="mini"
                    style="border-color:#97c5e9"
                    v-if="(scope.row.batchFile||'') != ''"
                    @click="getDown(scope.row)"
                    >下载</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <br />
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <el-button size="mini" style="display:inline-block;">GO</el-button>
      </div>
    </div>
    <!-- 商品中心->已导入订单 -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import {
  allIntoedOrderListRequest,
  cacelIntoedOrderRequest,
} from "../../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      totalPages: 1, // 总页码,
      pageNum: 1, // 当前页码
      total: 1, // 总条数
      pageSize: 10, // 每页条数

      aryList: [], // 数据列表
      token: "", // token
      status: "", // 状态
      queryParams: {
        orderNum: null,
        beginTime: null,
        endTime: null,
      },
    };
  },

  components: {},

  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getList();
    },

    getList() {
      // 3.4.获取订单数据
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        orderNum: this.queryParams.orderNum,
        params: {
          beginTime: this.queryParams.beginTime,
          endTime: this.queryParams.endTime,
        },
      };

      allIntoedOrderListRequest(data).then((res) => {
        console.log(res);
        if (res) {
          this.total = res.totals || 1;
          this.totalPages = Math.ceil(res.totals / this.pageSize) || 1;
          this.aryList = res.data;
        }
      });
    },

    cancelOrderBefore(item) {
      // 3.5.取消订单之前
      let _this = this;
      this.$msgbox({
        title: "提示",
        message: "是否确认取消导入订单?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.cancelOrder(item);
          }
        },
      });
    },

    cancelOrder(item) {
      // 3.6.取消订单
      cacelIntoedOrderRequest(item.batchId).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
          });

          setTimeout(() => {
            this.getList();
          }, 300);
        }
      });
    },

    search() {
      // 3.7.订单号检索
      this.pageNum = 1;
      this.getList();
    },

    watchOrder(item) {
      // 3.8.查看订单详情
      this.$router.push(
        "/interOrderDetail?obj=" + encodeURIComponent(JSON.stringify(item))
      );
    },

    getDown(item) {
      if(item.batchFile){
      var aLink = document.createElement("a");
          aLink.href = item.batchFile;
          aLink.download = "多商品模版.xls";
          aLink.style.display = "none";
          aLink.target = "_blank";
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink);
      }
    },

    SelectionChange() {},
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getList(); // 4.1.获取订单数据
    }
  },
};
</script>
